import 'core-js/stable';
import BAS from './bas.js';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.bas-spa').forEach((el) => (el.classList.contains('load') ? new BAS(el) : null));
});
